const prerender = false;
export {
  prerender
};
//# sourceMappingURL=_page.ts.js.map
